import React from 'react'
import {Star} from 'lucide-react'

function Testimonials() {
  const testimonials = [
    {
      name: 'Mariana Souza',
      city: 'São Paulo, SP',
      date: 'Ontem',
      photo: 'https://static.lumi.new/e0/e064a548cfbf45c480356d358acd07aa.png',
      text: 'Meu marido nem percebeu que era sem glúten. Pela primeira vez consegui fazer um pão realmente macio, igual eu comia antes de descobrir a intolerância.',
    },
    {
      name: 'Rafael Costa',
      city: 'Curitiba, PR',
      date: 'Há 3 dias',
      photo: 'https://static.lumi.new/cc/cce0712ecf30b46ab2148d6862186b73.png',
      text: 'Depois de anos evitando pão por causa da lactose, voltei a sentar à mesa e comer sem medo. Nunca mais comprei pão industrializado.',
    },
    {
      name: 'Helena Martins',
      city: 'Belo Horizonte, MG',
      date: 'Há 1 semana',
      photo: 'https://static.lumi.new/9b/9bcbf25cce004a25f7e3f0f47a8a416c.png',
      text: 'Fiz o bolo achando que ia precisar disfarçar o sabor. Ninguém percebeu que era sem açúcar refinado, juro. As crianças adoraram.',
    },
    {
      name: 'Bruno Alves',
      city: 'Porto Alegre, RS',
      date: 'Há 2 semanas',
      photo: 'https://static.lumi.new/ab/ab5e265f962a61db6d97343fd33d903f.png',
      text: 'A pizza de sábado voltou pra nossa casa. Ficou macia igual de pizzaria de verdade, minha esposa nem quis acreditar que era sem glúten.',
    },
    {
      name: 'Camila Rocha',
      city: 'Recife, PE',
      date: 'Há 3 semanas',
      photo: 'https://static.lumi.new/45/459bca05a3422a05d496dbb62d9b69f1.png',
      text: 'Já tentei tanta coisa "saudável" que não tinha gosto de nada. Aqui foi diferente: voltei a cozinhar com prazer, e ninguém em casa reclama.',
    },
    {
      name: 'Eduardo Lima',
      city: 'Fortaleza, CE',
      date: 'Há 1 mês',
      photo: 'https://static.lumi.new/34/3412740e4ac8113341ac35c516144e6a.png',
      text: 'Confesso que estava desconfiado. Mas os croissants saíram folhados e crocantes, parecendo padaria francesa. Recuperei um prazer que achava que tinha perdido.',
    },
  ]

  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10">
        <div className="text-center mb-14 animate-fade-up">
          <p className="text-[#5E774B] font-semibold text-sm mb-2">Mais de 15.000 clientes satisfeitos</p>
          <p className="text-[#D9891B] font-semibold uppercase tracking-wide text-sm mb-3">Quem já provou, aprovou</p>
          <h2 className="font-display text-[#49352B] text-3xl md:text-5xl font-bold">
            Histórias reais de quem transformou a cozinha
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-[#FCFAF5] rounded-[20px] p-7 border border-[#EBD9C3] shadow-sm hover:shadow-lg transition-shadow duration-300 animate-fade-up"
            >
              <div className="flex gap-1 mb-4">
                {Array.from({ length: 5 }).map((_, j) => (
                  <Star key={j} className="w-4 h-4 fill-[#D9891B] text-[#D9891B]" />
                ))}
              </div>
              <p className="text-[#49352B]/80 mb-6 leading-relaxed">"{t.text}"</p>
              <div className="flex items-center gap-3">
                <img src={t.photo} alt={t.name} className="w-14 h-14 rounded-full object-cover border-2 border-[#EBD9C3]" />
                <div>
                  <p className="font-semibold text-[#49352B]">{t.name}</p>
                  <p className="text-sm text-[#49352B]/60">{t.city} · {t.date}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Testimonials
